import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Person, Email, Phone, Category, Speaker, Print, Comment } from "@mui/icons-material";
import axios from "axios";
import { SERVER_URL, URL } from "constants/constant";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AptaTable from "examples/AptaTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const Author = ({ name, email }) => (
  <MDBox lineHeight={1}>
    <MDTypography display="block" variant="button" fontWeight="medium">
      {name}
    </MDTypography>
    <MDTypography variant="caption">{email}</MDTypography>
  </MDBox>
);

function Posters() {
  const [abstracts, setAbstracts] = useState([]);
  const [top6, setTop6] = useState([]);
  const [top25, setTop25] = useState([]);
  const [top25temp, setTop25temp] = useState([]);
  const [top6temp, setTop6temp] = useState([]);
  const [openAssign, setOpenAssign] = useState(false);
  const [selectedAbstract, setSelectedAbstract] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [judges, setJudges] = useState([]);
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const [selection, setSelection] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const fetchData = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/poster/get-all-posters`);
      setAbstracts(response.data?.data);
      setFilterAbstracts(response.data?.data);
    } catch (error) {
      console.error("Error fetching abstracts:", error);
    }
  };

  const fetchTop25 = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/poster/top-twenty-five`);
      setTop25(response.data?.data);
    } catch (error) {
      console.error("Error fetching abstracts:", error);
    }
  };
  const fetchTop25temp = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/poster/temp-selected-top-25`);
      setTop25temp(response.data?.data);
    } catch (error) {
      console.error("Error fetching abstracts:", error);
    }
  };
  const fetchTop6 = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/poster/top-six`);
      setTop6(response.data?.data);
    } catch (error) {
      console.error("Error fetching abstracts:", error);
    }
  };
  const fetchTop6temp = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/poster/temp-selected-top-6`);
      setTop6temp(response.data?.data);
    } catch (error) {
      console.error("Error fetching abstracts:", error);
    }
  };
  const fetchGroups = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/get-all-groups`);
      setGroups(response.data);
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchGroups();
    fetchTop25();
    fetchTop25temp();
    fetchTop6temp();

    fetchTop6();
  }, []);
  const fetchAll = () => {
    fetchData();
    fetchTop25();
    fetchTop6();
    fetchTop25temp();
    fetchTop6temp();
  };
  console.log({ top25temp });

  const handleOpenAssign = (abstract) => {
    setSelectedAbstract(abstract);
    setOpenAssign(true);
  };

  const handleCloseAssign = () => {
    setOpenAssign(false);
    setSelectedGroup("");
    setJudges([]);
  };

  const handleGroupChange = (event) => {
    const groupId = event.target.value;
    setSelectedGroup(groupId);
    const selectedGroupData = groups.find((group) => group._id === groupId);
    setJudges(selectedGroupData?.judges || []);
  };

  const handleAssign = async () => {
    if (!selectedGroup || !selectedAbstract) return;
    try {
      await axios.post(`${SERVER_URL}/poster/assign-group/${selectedAbstract._id}`, {
        groupId: selectedGroup,
      });
      Swal.fire("Successfully assigned the abstract");
      handleCloseAssign();
      fetchData();
    } catch (error) {
      console.error("Error assigning group:", error);
    }
  };
  const handleSubmit = async () => {
    console.log(selection);

    if (!selection) return;
    try {
      await axios.post(`${SERVER_URL}/poster/change-status`, {
        posterId: details._id,
        newStatus: selection,
      });
      handleClose();
      fetchData();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const handleOpen = (item) => {
    setDetails(item);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  // Filter
  const [statusFilter, setStatusFilter] = useState("All");
  const [filteredAbstracts, setFilterAbstracts] = useState([]);
  const [currentTable, setCurrentTable] = useState("");

  useEffect(() => {
    let filtered = abstracts;

    if (statusFilter !== "All") {
      filtered = filtered?.filter((item) => item.status === statusFilter);
    }

    if (searchQuery) {
      const lowercasedQuery = searchQuery.toLowerCase();
      filtered = filtered?.filter(
        (item) =>
          `${item.userId?.firstName} ${item.userId?.lastName}`
            .toLowerCase()
            .includes(lowercasedQuery) ||
          item.userId?.email.toLowerCase().includes(lowercasedQuery) ||
          (item.userId?.phoneNumber &&
            item.userId.phoneNumber.toLowerCase().includes(lowercasedQuery))
      );
    }

    setFilterAbstracts(filtered);
  }, [statusFilter, abstracts, searchQuery]);

  const exportToExcel = () => {
    const filteredAbstractsForExcel = filteredAbstracts?.map(
      ({
        title,
        category,
        subCategory,
        userId,
        group,
        marks,
        status,
        judges,
        hallNo,
        screen_board_Number,
        posterStatusType,
        printedPosterDisplay,
        oralPresentation,
        createdAt,
        description,
      }) => {
        const judge1 = judges?.[0];
        const judge2 = judges?.[1];

        const judge1Marks = marks?.find((i) => i?.judgeId?._id === judge1?._id);
        const judge2Marks = marks?.find((i) => i?.judgeId?._id === judge2?._id);

        return {
          Title: title || "",
          Category: category?.catName || "",
          Subcategory: subCategory?.subCatName || "",
          "Oral Presentation":
            oralPresentation === true ? "Yes" : oralPresentation === false ? "No" : "--",
          "Printed Poster":
            printedPosterDisplay === true ? "Yes" : printedPosterDisplay === false ? "No" : "--",
          Status: status || "",
          "Author Name": `${userId?.firstName || ""} ${userId?.lastName || ""}`,
          "Author Email": userId?.email || "",
          "Author Number": userId?.phoneNumber || "",
          Group: group?.groupName || "--",
          "Judge 1": judge1?.name || "",
          "Judge 1 Marks": judge1Marks?.score ? `${judge1Marks.score}/50` : "--",
          "Judge 1 Comment": judge1Marks?.comment || "--",
          "Judge 2": judge2?.name || "",
          "Judge 2 Marks": judge2Marks?.score ? `${judge2Marks.score}/50` : "--",
          "Judge 2 Comment": judge2Marks?.comment || "--",
          "Total Marks":
            judge1Marks?.score && judge2Marks?.score
              ? Number(judge1Marks.score) + Number(judge2Marks.score)
              : "--",
          "Submit Date": createdAt?.slice(0, 10) || "--",
          "Hall No.": hallNo || "--",
          "Screen/Board No": screen_board_Number || "--",
          Type: posterStatusType || "--",
          Description: description || "",
        };
      }
    );

    const worksheet = XLSX.utils.json_to_sheet(filteredAbstractsForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Abstracts");
    XLSX.writeFile(workbook, "Posters.xlsx");
  };

  //
  const handleConfirm25 = async () => {
    const myIds = top25?.map((i) => i?._id);

    console.log(myIds, "sdasd");
  };
  const handleConfirm6 = async () => {
    const myIds = top6?.map((i) => i?._id);

    console.log(myIds, "sdasd");
  };
  const handleDelete = async (posterId, userId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${URL}/api/iria/poster/delete-poster/${posterId}/${userId}`);
        Swal.fire("Deleted!", "The poster has been deleted.", "success");
        fetchData(); // Refresh the data to show the change
      } catch (error) {
        console.error("Error deleting poster:", error);
        Swal.fire("Error!", "Could not delete the poster.", "error");
      }
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={3} display="flex" justifyContent="space-between" alignItems="center">
        <MDBox flexGrow={1} mr={2}>
          <TextField
            label="Search by Name, Email, or Mobile"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </MDBox>
        <FormControl style={{ minWidth: 180 }}>
          <InputLabel>Status</InputLabel>
          <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Poster">Poster</MenuItem>
            <MenuItem value="Rejected">Rejected</MenuItem>
          </Select>
        </FormControl>
      </MDBox>
      <Box display={"flex"} mb={3} justifyContent={"end"}>
        <Button
          style={{ color: "white", backgroundColor: "#2ecc71" }}
          onClick={exportToExcel}
          variant="contained"
        >
          Download Excel
        </Button>
      </Box>
      <AptaTable
        columns={[
          "Author",
          "Title",
          "Category",
          "Status",
          "Group",
          "Judge1",
          "Judge2",
          "Total",
          "View",
          "Submit Date",
          "Hall No.",
          "Type",
          "Screen/Board No.",
          "Assign",
          "Delete",
        ]}
        rows={filteredAbstracts?.map((item) => ({
          Title: item.title,
          Category: item.category?.catName,
          Subcategory: item.subCategory?.subCatName,
          Author: (
            <Author
              name={item.userId?.firstName + " " + item.userId?.lastName}
              email={item.userId?.email}
            />
          ),
          Status: item.status,
          View: (
            <ButtonGroup size="small">
              <Button
                color="info"
                onClick={() => {
                  handleOpen(item);
                  setCurrentTable("all");
                }}
              >
                <Icon color="info">visibility</Icon>
              </Button>
            </ButtonGroup>
          ),
          Delete: (
            <Button
              color="error"
              size="small"
              onClick={() => handleDelete(item._id, item.userId?._id)}
            >
              <Icon>delete</Icon>
            </Button>
          ),

          Assign:
            item?.judges?.length > 0 ? (
              `${item?.marks?.length > 2 ? 2 : item?.marks?.length}/2`
            ) : (
              <ButtonGroup size="small">
                <Button color="info" onClick={() => handleOpenAssign(item)}>
                  <Icon color="info">assignment</Icon>
                </Button>
              </ButtonGroup>
            ),
          Group: item?.group?.groupName ? item?.group?.groupName : "--",
          Judge1: item?.marks?.find((i) => i?.judgeId?._id === item.judges?.[0]?._id)?.score
            ? item.marks?.find((i) => i?.judgeId?._id === item?.judges?.[0]?._id)?.score + "/50"
            : "--",
          Judge2: item?.marks?.find((i) => i?.judgeId?._id === item.judges?.[1]?._id)?.score
            ? item.marks?.find((i) => i?.judgeId?._id === item?.judges?.[1]?._id)?.score + "/50"
            : "--",

          Total:
            item.marks?.find((i) => i?.judgeId?._id === item.judges?.[0]?._id)?.score &&
            item.marks?.find((i) => i?.judgeId?._id === item.judges?.[1]?._id)?.score
              ? Number(item.marks?.find((i) => i?.judgeId?._id === item.judges?.[0]?._id)?.score) +
                Number(item.marks?.find((i) => i?.judgeId?._id === item.judges?.[1]?._id)?.score)
              : "--",
          "Submit Date": item?.createdAt?.slice(0, 10),
          "Hall No.": item?.hallNo ? item?.hallNo : "--",
          Type: item?.posterStatusType ? item?.posterStatusType : "--",
          "Screen/Board No.": item?.screen_board_Number ? item?.screen_board_Number : "--",
        }))}
      />
      <Box mt={10}></Box>

      {/* Top 25 buket */}
      <AptaTable
        title={`Bucket Top 25 Posters (${top25temp?.length}/25)`}
        columns={[
          "Author",
          "Title",
          "Category",
          "View",
          // "Hall No.",
          // 'Type',
          // "Screen/Board No."
        ]}
        rows={top25temp?.map((item) => ({
          Title: item.title,
          Category: item.category?.catName,
          Subcategory: item.subCategory?.subCatName,
          Author: (
            <Author
              name={item.userId?.firstName + " " + item.userId?.lastName}
              email={item.userId?.email}
            />
          ),
          Status: item.status,
          View: (
            <ButtonGroup size="small">
              <Button
                color="info"
                onClick={() => {
                  handleOpen(item);
                  setCurrentTable("top25-bucket");
                }}
              >
                <Icon color="info">visibility</Icon>
              </Button>
            </ButtonGroup>
          ),
          "Hall No.": item?.hallNo ? item?.hallNo : "--",
          Type: item?.posterStatusType ? item?.posterStatusType : "--",
          "Screen/Board No.": item?.screen_board_Number ? item?.screen_board_Number : "--",
        }))}
      />
      {/* Top 25 */}
      <AptaTable
        title={`Top 25 Posters (${top25?.length}/25)`}
        columns={[
          "Author",
          "Title",
          "Category",
          "View",
          // "Hall No.",
          // 'Type',
          // "Screen/Board No."
        ]}
        rows={top25?.map((item) => ({
          Title: item.title,
          Category: item.category?.catName,
          Subcategory: item.subCategory?.subCatName,
          Author: (
            <Author
              name={item.userId?.firstName + " " + item.userId?.lastName}
              email={item.userId?.email}
            />
          ),
          Status: item.status,
          View: (
            <ButtonGroup size="small">
              <Button
                color="info"
                onClick={() => {
                  handleOpen(item);
                  setCurrentTable("top25");
                }}
              >
                <Icon color="info">visibility</Icon>
              </Button>
            </ButtonGroup>
          ),
          "Hall No.": item?.hallNo ? item?.hallNo : "--",
          Type: item?.posterStatusType ? item?.posterStatusType : "--",
          "Screen/Board No.": item?.screen_board_Number ? item?.screen_board_Number : "--",
        }))}
      />
      <Box mt={10}></Box>
      {/* Top 6 bucket */}
      <AptaTable
        title={`Bucket Top 6 Posters (${top6temp?.length}/6)`}
        columns={[
          "Author",
          "Title",
          "Category",
          "View",
          // "Hall No.",
          // 'Type',
          //  "Screen/Board No."
        ]}
        rows={top6temp?.map((item) => ({
          Title: item.title,
          Category: item.category?.catName,
          Subcategory: item.subCategory?.subCatName,
          Author: (
            <Author
              name={item.userId?.firstName + " " + item.userId?.lastName}
              email={item.userId?.email}
            />
          ),
          Status: item.status,
          View: (
            <ButtonGroup size="small">
              <Button
                color="info"
                onClick={() => {
                  handleOpen(item);
                  setCurrentTable("top6-bucket");
                }}
              >
                <Icon color="info">visibility</Icon>
              </Button>
            </ButtonGroup>
          ),
          "Hall No.": item?.hallNo ? item?.hallNo : "--",
          Type: item?.posterStatusType ? item?.posterStatusType : "--",
          "Screen/Board No.": item?.screen_board_Number ? item?.screen_board_Number : "--",
        }))}
      />
      {/* Top 6 */}
      <AptaTable
        title={`Top 6 Posters (${top6?.length}/6)`}
        columns={[
          "Author",
          "Title",
          "Category",
          "Status",
          "View",
          // "Hall No.",
          // 'Type',
          // "Screen/Board No."
        ]}
        rows={top6?.map((item) => ({
          Title: item.title,
          Category: item.category?.catName,
          Subcategory: item.subCategory?.subCatName,
          Author: (
            <Author
              name={item.userId?.firstName + " " + item.userId?.lastName}
              email={item.userId?.email}
            />
          ),
          Status: item.status,
          View: (
            <ButtonGroup size="small">
              <Button
                color="info"
                onClick={() => {
                  handleOpen(item);
                  setCurrentTable("top6");
                }}
              >
                <Icon color="info">visibility</Icon>
              </Button>
            </ButtonGroup>
          ),
          "Hall No.": item?.hallNo ? item?.hallNo : "--",
          Type: item?.posterStatusType ? item?.posterStatusType : "--",
          "Screen/Board No.": item?.screen_board_Number ? item?.screen_board_Number : "--",
        }))}
      />
      <Dialog
        open={openAssign}
        handleSubmit={handleSubmit}
        onClose={handleCloseAssign}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Assign group</DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <FormControl fullWidth sx={{ marginTop: 4, paddingTop: 1 }}>
            <InputLabel sx={{}}>Select Group</InputLabel>
            <Select
              value={selectedGroup}
              name="group"
              onChange={handleGroupChange}
              fullWidth
              style={{ height: 40, marginTop: 2 }}
            >
              <MenuItem value="Select any group" disabled>
                Select any group
              </MenuItem>
              {groups?.map((group) => (
                <MenuItem key={group._id} value={group._id}>
                  {group.groupName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {judges?.length > 0 && (
            <Box sx={{ padding: 2, display: "flex", flexDirection: "column", gap: 3 }}>
              <p style={{ textAlign: "center" }}>Judges</p>
              <Box>
                <h6>Judge 1</h6>
                <p>{judges?.[0]?.name}</p>
              </Box>
              <Box>
                <h6>Judge 2</h6>
                <p>{judges?.[1]?.name}</p>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAssign} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAssign} variant="contained" style={{ color: "white" }}>
            Assign
          </Button>
        </DialogActions>
      </Dialog>

      {details && (
        <DialogForView
          details={details}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
          open={open}
          currentTable={currentTable}
          selection={selection}
          setSelection={setSelection}
          fetchData={fetchAll}
        />
      )}
    </DashboardLayout>
  );
}

export default Posters;

const DialogForView = ({
  details,
  handleSubmit,
  handleClose,
  open,
  selection,
  setSelection,
  currentTable,
  fetchData,
}) => {
  const [isTopSix, setIsTopSix] = useState(false);
  const [isTopTwentyFive, setIsTopTwentyFive] = useState(false);
  const [type, settype] = useState("");
  const [hallNo, sethallNo] = useState("");
  const [screen_board_Number, setscreen_board_Number] = useState("");

  useEffect(() => {
    if (details) {
      setIsTopSix(details?.isTop6);
      setIsTopTwentyFive(details?.isTop25);
      settype(details?.posterStatusType);
      sethallNo(details?.hallNo);
      setscreen_board_Number(details?.screen_board_Number);
    }
  }, [details]);

  const handleToggle = async (type, isSelected) => {
    // let url
    // if (type.includes('bucket')) {
    //     url = `${SERVER_URL}/abstracts/temp-${isSelected ? `select` : 'unselect'}-${type === 'top-twenty-five-bucket' ? 'top-25' : 'top-6'}`;

    // } else {
    //     url = `${SERVER_URL}/abstracts/${isSelected ? `select-for` : 'unselect-from'}-${type}`;

    // }
    // try {
    //     await axios.post(url, { abstractId: details?._id });
    //     if (type === 'top-six') setIsTopSix(isSelected);
    //     if (type === 'top-twenty-five' || type === "top-twenty-five-bucket") setIsTopTwentyFive(isSelected);
    //     fetchData()
    //     if (type?.includes("bucket")) {
    //         handleClose()
    //     }
    // } catch (error) {
    //     console.error(`Error updating ${type}:`, error);
    // }
    let url;
    if (type.includes("bucket")) {
      // url = `${SERVER_URL}/poster/${isSelected ? 'select-for' : 'unselect-from'}-${type}`;

      url = `${SERVER_URL}/poster/temp-${isSelected ? `select` : "unselect"}-${
        type === "top-twenty-five-bucket" ? "top-25" : "top-6"
      }`;
    } else {
      url = `${SERVER_URL}/poster/${isSelected ? `select-for` : "unselect-from"}-${type}`;
    }
    try {
      await axios.post(url, { posterId: details?._id });
      if (type === "top-six") setIsTopSix(isSelected);
      if (type === "top-twenty-five" || type === "top-twenty-five-bucket")
        setIsTopTwentyFive(isSelected);
      fetchData();
      if (type?.includes("bucket")) {
        handleClose();
      }
    } catch (error) {
      console.error(`Error updating ${type}:`, error);
    }
    // const url = `${SERVER_URL}/poster/${isSelected ? 'select-for' : 'unselect-from'}-${type}`;
  };
  let judge1Score = details?.marks?.find(
    (i) => i?.judgeId?._id === details?.judges?.[0]?._id
  )?.score;
  let judge2Score = details?.marks?.find(
    (i) => i?.judgeId?._id === details?.judges?.[1]?._id
  )?.score;
  let bothJudgesScored = judge1Score !== undefined && judge2Score !== undefined;

  const handleSaveSchedule = async () => {
    try {
      await axios.put(`${SERVER_URL}/poster/update/${details?._id}`, {
        hallNo,
        screen_board_Number,
        posterStatusType: type,
      });
      fetchData();
    } catch (error) {
      console.error("Error saving schedule:", error);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        settype("");
        setscreen_board_Number("");
        sethallNo("");
      }}
      maxWidth="md"
      fullWidth
      sx={{ borderRadius: 3, overflow: "hidden" }}
    >
      <DialogTitle
        style={{ color: "white" }}
        sx={{
          bgcolor: "#1565c0",
          color: "white",
          textAlign: "center",
          fontWeight: "bold",
          py: 2,
          fontSize: "1.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ mr: 1 }}>info</Icon> Poster Details
      </DialogTitle>

      <DialogContent sx={{ p: 4, bgcolor: "#fafafa" }}>
        <Box display="flex" flexDirection="column" gap={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            borderBottom="1px solid #ddd"
          >
            <Typography variant="body2">
              <Person sx={{ mr: 1 }} />
              <strong>Author:</strong> {details.userId?.firstName} {details.userId?.lastName}
            </Typography>
          </Box>
          <Typography variant="body2">
            <Email sx={{ mr: 1 }} />
            <strong>Email:</strong> {details.userId?.email}
          </Typography>
          <Typography variant="body2" sx={{ py: 1, borderBottom: "1px solid #ddd" }}>
            <Phone sx={{ mr: 1 }} />
            <strong>Phone:</strong> {details.userId?.phoneNumber}
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            borderBottom="1px solid #ddd"
          >
            <Typography variant="body2">
              <Category sx={{ mr: 1 }} />
              <strong>Category:</strong> {details.category?.catName}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            borderBottom="1px solid #ddd"
          >
            <Typography variant="body2">
              <Category sx={{ mr: 1 }} />
              <strong>Sub category:</strong> {details.subCategory?.subCatName}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            borderBottom="1px solid #ddd"
          >
            <Typography variant="body2">
              <Speaker sx={{ mr: 1 }} />
              <strong>
                E I. Pos. Play: Oral Presentations (5 minutes) at the Exhibit area:
              </strong>{" "}
              {details?.oralPresentation ? "Yes" : "No"}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
            borderBottom="1px solid #ddd"
          >
            <Typography variant="body2">
              <Print sx={{ mr: 1 }} />
              <strong>F I. Pos. Print: Printed Poster display:</strong>{" "}
              {details?.printerPosterDisplay ? "Yes" : "No"}
            </Typography>
          </Box>

          <Typography variant="h5" fontWeight="bold">
            {details.title}
          </Typography>
          <Typography variant="body1">{details.description}</Typography>

          {details?.subCategory?.subCatName ===
            "I. Pos. Play: Oral Presentations (5 Minutes) at the Exhibit area" && (
            <Typography variant="body2" sx={{ py: 1, borderBottom: "1px solid #ddd" }}>
              <Comment sx={{ mr: 1 }} />
              <strong>Accepted:</strong> {details?.subCategoryAccepted ? "Yes" : "No"}
            </Typography>
          )}

          {details?.subCategoryType !== "Null" && (
            <Typography variant="body2" sx={{ py: 1, borderBottom: "1px solid #ddd" }}>
              <Category sx={{ mr: 1 }} />
              <strong>Category Type:</strong> {details?.subCategoryType}
            </Typography>
          )}

          {details?.judges?.length > 0 && (
            <>
              <Box style={{ width: "100%", textAlign: "center" }}>
                <p>Assigned To ({details?.group?.groupName})</p>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                py={1}
                borderBottom="1px solid #ddd"
              >
                <Typography variant="body2">
                  <Person sx={{ mr: 1 }} />
                  <strong>Judge1:</strong> {details.judges?.[0]?.name}
                </Typography>
                <Typography variant="body2">
                  <strong>Marks:</strong>{" "}
                  {details.marks?.find((i) => i?.judgeId?._id === details.judges?.[0]?._id)?.score
                    ? details.marks?.find((i) => i?.judgeId?._id === details.judges?.[0]?._id)
                        ?.score + "/50"
                    : "--"}{" "}
                </Typography>
              </Box>
              {details.marks?.find((i) => i?.judgeId?._id === details.judges?.[0]?._id)
                ?.comment && (
                <Typography variant="body2">
                  <strong>Comment:</strong>{" "}
                  {
                    details.marks?.find((i) => i?.judgeId?._id === details.judges?.[0]?._id)
                      ?.comment
                  }
                </Typography>
              )}

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                py={1}
                borderBottom="1px solid #ddd"
              >
                <Typography variant="body2">
                  <Person sx={{ mr: 1 }} />
                  <strong>Judge2:</strong> {details.judges?.[1]?.name}
                </Typography>
                <Typography variant="body2">
                  <strong>Marks:</strong>{" "}
                  {details.marks?.find((i) => i?.judgeId?._id === details.judges?.[1]?._id)?.score
                    ? details.marks?.find((i) => i?.judgeId?._id === details.judges?.[1]?._id)
                        ?.score + "/50"
                    : "--"}{" "}
                </Typography>
              </Box>
              {details.marks?.find((i) => i?.judgeId?._id === details.judges?.[1]?._id)
                ?.comment && (
                <Typography variant="body2">
                  <strong>Comment:</strong>{" "}
                  {
                    details.marks?.find((i) => i?.judgeId?._id === details.judges?.[1]?._id)
                      ?.comment
                  }
                </Typography>
              )}

              <Typography textAlign={"center"} variant="body2">
                <strong>Total:</strong>{" "}
                {details.marks?.find((i) => i?.judgeId?._id === details.judges?.[0]?._id)?.score &&
                details.marks?.find((i) => i?.judgeId?._id === details.judges?.[1]?._id)?.score
                  ? Number(
                      details.marks?.find((i) => i?.judgeId?._id === details.judges?.[0]?._id)
                        ?.score
                    ) +
                    Number(
                      details.marks?.find((i) => i?.judgeId?._id === details.judges?.[1]?._id)
                        ?.score
                    )
                  : "--"}
              </Typography>
            </>
          )}
          {details?.status !== "Rejected" && details?.status !== "Pending" && (
            <>
              <Typography variant="h6" fontWeight="bold">
                Schedule
              </Typography>
              <Box display="flex" flexDirection="row" alignItems="center" gap={2} mt={3}>
                <TextField
                  label="Hall No."
                  type="text"
                  value={hallNo}
                  onChange={(e) => sethallNo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  // sx={{ width: 120 }}
                />
                <FormControl fullWidth sx={{ minWidth: 120 }}>
                  <InputLabel>Type</InputLabel>
                  <Select
                    style={{ height: 40 }}
                    value={type}
                    onChange={(e) => settype(e.target.value)}
                  >
                    <MenuItem value="E-Poster">E-Poster</MenuItem>
                    <MenuItem value="Printed Poster">Printed Poster</MenuItem>
                    <MenuItem value="Play Poster">Play Poster</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label={
                    type === "E-Poster"
                      ? "Screen No"
                      : type === "Printed Poster"
                      ? "Board No"
                      : "Screen No/Board No"
                  }
                  type="text"
                  value={screen_board_Number}
                  onChange={(e) => setscreen_board_Number(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth

                  // sx={{ width: 120 }}
                />
              </Box>
              <Button
                onClick={handleSaveSchedule}
                variant="contained"
                color="primary"
                style={{ color: "white" }}
              >
                Save
              </Button>
            </>
          )}
          {bothJudgesScored && details?.status === "Pending" && (
            <Box>
              <Typography variant="h6" fontWeight="bold">
                Select Option:
              </Typography>
              <RadioGroup value={selection} onChange={(e) => setSelection(e.target.value)}>
                <FormControlLabel value="Poster" control={<Radio />} label="E-Poster" />
                <FormControlLabel value="Play Poster" control={<Radio />} label="Play Poster" />
                <FormControlLabel
                  value="Printed Poster"
                  control={<Radio />}
                  label="Printed Poster"
                />
                <FormControlLabel value="Rejected" control={<Radio />} label="Not Selected" />
              </RadioGroup>
            </Box>
          )}
          {details?.status === "Poster" && (
            <Box mt={3}>
              {/* {currentTable !== 'top6' && <Typography variant='h6' fontWeight='bold'>Selection Status</Typography>}
                        {currentTable === 'top25' && <FormControlLabel
                            control={<Switch checked={isTopSix} onChange={(e) => handleToggle('top-six', e.target.checked)} />}
                            label='Top 6'
                        />}
                        {currentTable === "all" && <FormControlLabel
                            control={<Switch checked={isTopTwentyFive} onChange={(e) => handleToggle('top-twenty-five', e.target.checked)} />}
                            label='Top 25'
                        />} */}

              {/*  */}
              {currentTable !== "top6" && (
                <Typography variant="h6" fontWeight="bold">
                  Selection Status
                </Typography>
              )}
              {currentTable === "top25" && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={isTopSix}
                      onChange={(e) => handleToggle("top-six-bucket", e.target.checked)}
                    />
                  }
                  label="Top 6 Bucket"
                />
              )}
              {currentTable === "top25-bucket" && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={isTopTwentyFive}
                      onChange={(e) => handleToggle("top-twenty-five", e.target.checked)}
                    />
                  }
                  label="Top 25"
                />
              )}
              {currentTable === "top25-bucket" && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={true}
                      onChange={(e) => handleToggle("top-twenty-five-bucket", e.target.checked)}
                    />
                  }
                  label="Top 25 Bucket"
                />
              )}
              {currentTable === "all" && (
                <FormControlLabel
                  control={
                    <Switch
                      // checked={isTopTwentyFive}
                      onChange={(e) => handleToggle("top-twenty-five-bucket", e.target.checked)}
                    />
                  }
                  label="Top 25 Bucket"
                />
              )}

              {currentTable === "top6-bucket" && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={isTopSix}
                      onChange={(e) => handleToggle("top-six", e.target.checked)}
                    />
                  }
                  label="Top 6"
                />
              )}
              {currentTable === "top6-bucket" && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={true}
                      onChange={(e) => handleToggle("top-six-bucket", e.target.checked)}
                    />
                  }
                  label="Top 6 Bucket"
                />
              )}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", p: 3, bgcolor: "#f0f0f0" }}>
        <Button
          onClick={() => {
            handleClose();
            settype("");
            setscreen_board_Number("");
            sethallNo("");
          }}
          variant="contained"
          color="primary"
          style={{ color: "white" }}
          sx={{
            borderRadius: 2,
            px: 4,
            py: 1.5,
            fontSize: "1rem",
            textTransform: "none",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
          }}
        >
          Close
        </Button>
        {bothJudgesScored && details?.status === "Pending" && (
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            style={{ color: "white" }}
            sx={{
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              textTransform: "none",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
            }}
          >
            Submit
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
